export const SERP_SEARCH_EXPIRATION_MS = 30 * 60 * 1000;
